import { render, staticRenderFns } from "./AiPricingCard.vue?vue&type=template&id=0c9de502&scoped=true&"
import script from "./AiPricingCard.vue?vue&type=script&lang=js&"
export * from "./AiPricingCard.vue?vue&type=script&lang=js&"
import style0 from "./AiPricingCard.vue?vue&type=style&index=0&id=0c9de502&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9de502",
  null
  
)

export default component.exports